var render, staticRenderFns
import script from "./SidebarListItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarListItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarListItem.vue?vue&type=style&index=0&id=54ba7646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports